import { render, staticRenderFns } from "./ExitScreen.vue?vue&type=template&id=464dd2a2&"
import script from "./ExitScreen.vue?vue&type=script&lang=js&"
export * from "./ExitScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports